import {AfterViewInit, Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {MatTableDataSource} from "@angular/material/table";
import {User} from "../../auth/models/User";
import {MatPaginator} from "@angular/material/paginator";
import {Subject, takeUntil} from "rxjs";
import {AdminService} from "../services/admin.service";
import {AuthenticationService} from "../../auth/services/authentication.service";
import {MatDialog} from "@angular/material/dialog";
import {TranslateService} from "@ngx-translate/core";
import Swal from "sweetalert2";
import {LeagueDialogComponent} from "./league-dialog/league-dialog.component";
import {News, Pagination} from "../../shared/SharedEntities";

@Component({
  selector: 'app-league',
  templateUrl: './league.component.html',
  styleUrls: ['./league.component.scss']
})
export class LeagueComponent implements OnInit, AfterViewInit, OnDestroy {
  leagues = new MatTableDataSource<any>();
  currentUser!: User;
  displayedColumns: string[] = ['name', 'open', 'remove'];
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  totalItems = 0;
  pageSize = 10;
  private destroy$ = new Subject<void>();

  constructor(
    private adminService: AdminService,
    private authenticationService: AuthenticationService,
    public dialog: MatDialog,
    private translate: TranslateService
  ) {
    this.authenticationService.currentUser.pipe(takeUntil(this.destroy$)).subscribe(x => {
      this.currentUser = x!;
    });
  }

  ngOnInit() {
  }

  ngAfterViewInit() {
    this.loadData();
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  loadData(page: number = 0, pageSize: number = this.pageSize) {
    if (this.currentUser) {
      this.adminService.getAllLeagues(page, pageSize).subscribe((result: Pagination<any>) => {
        this.leagues = new MatTableDataSource(result.content);
        this.totalItems = result.totalElements;
        this.paginator.length = this.totalItems;
        this.paginator.pageIndex = result.pageable.pageNumber;
      }, (error: any) => {
        console.error(error);
      });
    }
  }

  onPageChange(event: any) {
    this.loadData(event.pageIndex, event.pageSize);
  }

  deleteLeague(leagueId: string): void {
    this.translate.get([
      'Are you sure?',
      'You won\'t be able to revert this!',
      'Yes, delete it!',
      'No, cancel!',
      'Deleted!',
      'The user has been deleted.',
      'Error',
      'An error occurred while deleting the league.'
    ]).subscribe(translations => {
      Swal.fire({
        title: translations['Are you sure?'],
        text: translations['You won\'t be able to revert this!'],
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: translations['Yes, delete it!'],
        cancelButtonText: translations['No, cancel!']
      }).then((result: any) => {
        if (result.isConfirmed) {
          this.adminService.deleteLeague(leagueId).subscribe(() => {
            Swal.fire(translations['Deleted!'], translations['The league has been deleted.'], 'success');
            this.loadData();
          }, (error) => {
            Swal.fire(translations['Error'], error.error.message, 'error');
          });
        }
      });
    });
  }

  openCreateLeagueDialog(): void {
    const dialogRef = this.dialog.open(LeagueDialogComponent, {
      width: '400px',
      height: '400px',
      data: {user: null}
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.loadData();
      }
    });
  }

  openEditLeagueDialog(league: any): void {
    const dialogRef = this.dialog.open(LeagueDialogComponent, {
      width: '400px',
      height: '400px',
      data: {league}
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.loadData();
      }
    });
  }

}
